import { createSignal, onCleanup, onMount } from "solid-js";
import { actions } from "../SHARED/store";
import { splitProps } from "solid-js";

export default function PageNotFound(props: { path: string; base?: string; duration?: number; speed?: number }) {
  const [local] = splitProps(props, ["base", "duration", "path", "speed"]);
  const duration = local.duration ?? 3;
  const speed = local.speed ?? 1;
  const [$timer, setTimer] = createSignal(duration);
  const navigate = actions.navigate;
  let interval = undefined;
  onMount(() => {
    interval = setInterval(() => {
      const time = $timer();
      if (time <= 0) {
        navigate({ base: local.base, path: local.path });
      } else {
        setTimer((s) => s - 1);
      }
    }, speed * 1000);
  });

  onCleanup(() => {
    if (interval != undefined) {
      clearInterval(interval);
    }
  });

  return (
    <div class="flex flex-col w-full min-h-full items-center justify-center">
      <h1>Error 404: Page Not Found</h1>
      <p>You will be redirected to the nearest page in {$timer().toFixed(0)} seconds...</p>
    </div>
  );
}
